export default __webpack_public_path__ + "static/media/documents.472d1064.png";